import portalLogo from './logo/portal-logo.png';

export const LogoIcon = () => (
  <img style={{ width: 36, height: 'auto' }} src={portalLogo} alt="" />
);
